import React, { useState, useEffect } from 'react';

const PHONE = '+48 536 030 706';
const PHONE_HREF = 'tel:+48536030706';

const links = [
  { label: 'Strona główna', href: '#home' },
  { label: 'O samochodzie', href: '#about' },
  { label: 'Galeria', href: '#gallery' },
  { label: 'Opinie', href: '#reviews' },
  { label: 'Kontakt', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleLink = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 500,
        transition: 'all 0.4s ease',
        background: scrolled
          ? 'rgba(5, 10, 26, 0.92)'
          : 'transparent',
        backdropFilter: scrolled ? 'blur(20px)' : 'none',
        WebkitBackdropFilter: scrolled ? 'blur(20px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(59,130,246,0.1)' : 'none',
      }}
    >
      <nav
        style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: '0 24px',
          height: 72,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 24,
        }}
      >
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => handleLink(e, '#home')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            textDecoration: 'none',
            flexShrink: 0,
          }}
          aria-label="Infiniti FX35 – powrót do strony głównej"
        >
          <InfinitiLogo />
          <div style={{ lineHeight: 1 }}>
            <span
              style={{
                display: 'block',
                fontSize: 13,
                fontWeight: 700,
                letterSpacing: '0.15em',
                color: '#f4f5f7',
              }}
            >
              INFINITI
            </span>
            <span
              style={{
                display: 'block',
                fontSize: 10,
                fontWeight: 400,
                letterSpacing: '0.3em',
                color: '#3b82f6',
              }}
            >
              FX35
            </span>
          </div>
        </a>

        {/* Desktop nav links */}
        <ul
          style={{
            display: 'flex',
            gap: 4,
            listStyle: 'none',
            margin: 0,
            padding: 0,
          }}
          className="hidden md:flex"
        >
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                onClick={(e) => handleLink(e, l.href)}
                style={{
                  display: 'block',
                  padding: '8px 14px',
                  fontSize: 13,
                  fontWeight: 500,
                  letterSpacing: '0.04em',
                  color: 'rgba(244,245,247,0.75)',
                  textDecoration: 'none',
                  borderRadius: 8,
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#f4f5f7';
                  e.currentTarget.style.background = 'rgba(59,130,246,0.08)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = 'rgba(244,245,247,0.75)';
                  e.currentTarget.style.background = 'transparent';
                }}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Phone CTA */}
        <a
          href={PHONE_HREF}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '10px 20px',
            borderRadius: 40,
            fontSize: 13,
            fontWeight: 600,
            color: '#f4f5f7',
            textDecoration: 'none',
            background: 'linear-gradient(135deg, #1a3460, #3b82f6)',
            boxShadow: '0 4px 20px rgba(59,130,246,0.35)',
            transition: 'all 0.3s ease',
            flexShrink: 0,
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = '0 8px 32px rgba(59,130,246,0.6)';
            e.currentTarget.style.transform = 'translateY(-1px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(59,130,246,0.35)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.22 2 2 0 012 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14h-.08z" />
          </svg>
          <span className="hidden sm:inline">{PHONE}</span>
          <span className="sm:hidden">Zadzwoń</span>
        </a>

        {/* Mobile hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="flex md:hidden"
          style={{
            background: 'none',
            border: 'none',
            padding: 8,
            cursor: 'none',
            color: '#f4f5f7',
          }}
          aria-label={menuOpen ? 'Zamknij menu' : 'Otwórz menu'}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            {menuOpen ? (
              <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" />
            ) : (
              <>
                <line x1="3" y1="6" x2="21" y2="6" strokeLinecap="round" />
                <line x1="3" y1="12" x2="21" y2="12" strokeLinecap="round" />
                <line x1="3" y1="18" x2="21" y2="18" strokeLinecap="round" />
              </>
            )}
          </svg>
        </button>
      </nav>

      {/* Mobile menu */}
      {menuOpen && (
        <div
          style={{
            background: 'rgba(5,10,26,0.97)',
            backdropFilter: 'blur(20px)',
            borderTop: '1px solid rgba(59,130,246,0.1)',
            padding: '16px 24px 24px',
          }}
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleLink(e, l.href)}
              style={{
                display: 'block',
                padding: '14px 0',
                fontSize: 15,
                fontWeight: 500,
                color: 'rgba(244,245,247,0.85)',
                textDecoration: 'none',
                borderBottom: '1px solid rgba(59,130,246,0.08)',
              }}
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}

function InfinitiLogo() {
  return (
    <svg width="36" height="24" viewBox="0 0 56 28" fill="none">
      <path
        d="M14 14C14 8.477 18.477 4 24 4C27.5 4 30.6 5.8 32.5 8.5L28 14L32.5 19.5C30.6 22.2 27.5 24 24 24C18.477 24 14 19.523 14 14Z"
        stroke="#3b82f6"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M42 14C42 19.523 37.523 24 32 24C28.5 24 25.4 22.2 23.5 19.5L28 14L23.5 8.5C25.4 5.8 28.5 4 32 4C37.523 4 42 8.477 42 14Z"
        stroke="#3b82f6"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  );
}
